import React from 'react';
import _ from 'lodash';

import styles from './MultipleChoice.module.scss';
import Radio from '../../../../Form/Radio/Radio';

type MultipleChoiceProps = {
  question: any;
  tracking: any;
  config: any;
  onChange: Function;
};

function MultipleChoice(props: MultipleChoiceProps) {
  const { question, tracking, config, onChange } = props;
  const { showCorrectAnswer, showYourAnswers } = config;
  const { answer, submitted } = tracking;

  const allowMultipleAnswer =
    _.filter(question.choices, (c) => c.correct).length > 1;

  function handleChange(e: any) {
    const { id, name, value, type, checked } = e.target;
    onChange &&
      onChange(e, {
        id,
        name,
        value,
        type,
        checked,
        questionId: question.resourceId,
      });
  }

  return (
    <div className={styles.MultipleChoice}>
      {_.map(question.choices, (choice) => {
        const checked = _.includes(answer, choice.resourceId.toString());
        return (
          <Radio
            id={choice.resourceId}
            type={allowMultipleAnswer ? 'checkbox' : null}
            name={question.resourceId}
            key={choice.resourceId}
            label={choice.text}
            value={choice.resourceId}
            checked={checked}
            onChange={handleChange}
            disabled={submitted}
            correct={showYourAnswers && checked && submitted && choice.correct}
            incorrect={
              showYourAnswers && checked && submitted && !choice.correct
            }
            showAnswer={showCorrectAnswer && submitted && choice.correct}
            className={styles.MultipleChoice__radio}
          />
        );
      })}
    </div>
  );
}

export default MultipleChoice;
